/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TimeEntryResponse = {
    properties: {
        id: {
            type: 'string',
            format: 'uuid4',
        },
        timestamp: {
            type: 'string',
            format: 'date-time',
        },
        userId: {
            type: 'number',
            isRequired: true,
        },
        type: {
            type: 'string',
        },
        timePatchType: {
            type: 'TimePatchTypeEnum',
            isRequired: true,
        },
        payload: {
            type: 'TimePatchEntryPayload',
            isRequired: true,
        },
        user: {
            type: 'UserSmall',
            isRequired: true,
        },
    },
} as const;
